import React, { Suspense } from "react";
import { withRouter, Switch, Redirect, Route } from "react-router-dom";
import { connect } from "react-redux";
import { getUserRole } from "../../utils/UserDetails";
import UserLayout from "../../layouts/UserLayout";
import PrivateRoute from "../../routers/PrivateRoute";
import CustomerInvoiceReport from "./CustomerInvoiceReport";
import DeliveryNotesReport from "./DeliveryNotesReport";
import TotalStockReport from "./TotalStockReport";

const App = ({ match }) => {
  return (
    <div className="dashboard-wrapper">
      <UserLayout>
        <Suspense fallback={<div className="loading" />}>
          <Switch>
            <Redirect
              exact
              from={`${match.url}/`}
              to={
                getUserRole()
                  ? `${match.url}/delivery-note-report`
                  : `${match.url}/login`
              }
            />

            <PrivateRoute
              exact
              path={`${match.url}/delivery-note-report`}
              component={DeliveryNotesReport}
              menuId="report.delivery.note"
            />
            
            <PrivateRoute
              exact
              path={`${match.url}/customer-invoice-report`}
              component={CustomerInvoiceReport}
              menuId="report.customer.invoice"

            />
            <PrivateRoute
              exact
              path={`${match.url}/total-stock-report`}
              component={TotalStockReport}
              menuId="report.total.stock"

            />
          </Switch>
        </Suspense>
      </UserLayout>
    </div>
  );
};

export default withRouter(connect(null, {})(App));
